<template lang="pug">
div
  validation-provider(:rules="requiredEmails ? 'hasEmail' : ''", v-slot="{ errors }", :name="nomeAba + '/Email(s)'")
    el-table(v-model="emailsValidationValues" hidden :data="emails")
  validation-provider(:rules="requiredEmails ? 'email:@' + nomeAba + '/Email(s)' : ''", name="$ignoreEmail$")
    app-label(label="Email(s):", :required="requiredEmails")
    el-input.input(
      label='Email',
      :class="{'erro' : errorsEmail && errorsEmail.length}"
      v-model="email"
    )
      el-button.style(
        slot="append",
        icon="el-icon-plus",
        @click="addEmail(email)",
        :disabled="!isEmailValid",
      )
    span.help.erro {{ errorsEmail ? errorsEmail[0] : '' }}

    div.tag-app-input.marginTop
      el-tag(
        v-for="(email, index) in emails",
        :key="index",
        closable,
        type="info",
        size="medium",
        @close="removeEmail(index)"
      ) {{ email }}
</template>

<script>
import AppLabel from '@/components/AppLabel'

export default {

  components: {
    AppLabel
  },

  data () {
    return {
      email: ''
    }
  },

  props: {
    emails: {
      type: Array,
      required: true
    },

    // Atenção: workaround para contornar problema na validação do componente de email.
    // Use 'delete this.$refs.observer.refs['$ignoreEmail$']' antes de chamar a validação onde esse componente é usado dentro de um ValidationObserver
    requiredEmails: {
      type: Boolean,
      default: false
    },

    nomeAba: {
      type: String,
      required: true
    },

    observer: {
      required: true
    }
  },

  computed: {
    errorsEmail () {
      if (this.observer) {
        return this.observer.errors[ this.nomeAba + '/Email(s)' ]
      }
      return []
    },

    emailsValidationValues () {
      return { emails: this.emails }
    },

    isEmailValid () {
      const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
      const match = regex.test(this.email)
      if (match) {
        return true
      }
      return false
    }
  },

  methods: {
    addEmail (email) {
      this.emails.push(email)
      this.email = ''
    },

    removeEmail (index) {
      this.emails.splice(index, 1)
    },

    clearInput () {
      this.email = ''
    }

  }

}

</script>

<style lang="scss" scoped>

.marginTop {
  margin-top: 5px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInputEmail.vue